const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./purchase-fullcont-handler')
const {
	buildChatCardWarning,
	readFullcontField,
	countMultitableLines,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	load: { start: (detail) => { load(detail) } },
	submit: { start: (detail) => { submit(detail) } },
	typing: { start: (detail) => { typing(detail) } },
	beforeChat: { start: (detail) => { beforeChat(detail) } },
}

const PURCHASE_QUESTIONS = [
	'Purchase status?',
	'Total purchase amount?',
	'Were there any changes in the purchase orders?',
	'Can I get a summary of this purchase?',
]

const PURCHASE_BEFORE_QUESTIONS = ['Last purchase price?', 'Estimated total cost?', 'Should I negotiate?', 'What do you think about the quantity being purchased?']


function getGeneralQuestions(type) {
	if (type === 'purchase') {
		return PURCHASE_QUESTIONS
	}

	if (type === 'purchaseBefore') {
		return PURCHASE_BEFORE_QUESTIONS
	}
}

function load(detail) {
	const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
	const recordId = fullcontActivo.getAttribute('data-dbid')

	const lineCount = fullcontActivo
		? countMultitableLines(fullcontActivo, 'purchase_form_purchase_vs_item')
		: 0

	const details = fullcontActivo
		? [
				{ label: 'Purchase code', value: readFullcontField(fullcontActivo, 'purchase_form_code') },
				{ label: 'Provider', value: readFullcontField(fullcontActivo, 'purchase_form_provider_id') },
				{ label: 'Purchase date', value: readFullcontField(fullcontActivo, 'purchase_form_date') },
				{ label: 'Estado', value: readFullcontField(fullcontActivo, 'purchase_form_status') },
				{
					label: 'Products in the detail',
					value: lineCount ? `${lineCount} línea(s)` : '—',
				},
		  ]
		: []

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Saved purchase',
		recordId: recordId || '—',
		details,
		scopeNote: 'The conversation corresponds only to this purchase and to the history already saved here.',
	})

	if (recordId) {
		chat.start({
			dest: 'chat',
			act: 'quickview',
			actQuickview: 'show',
			type: 'purchase',
			entity: 'purchase',
			question: detail.question ?? '',
			recordId: recordId,
			ev: detail.ev,
			generalQuestions: getGeneralQuestions('purchase'),
			cardWarning: cardWarning,
		})

		const msj = handler.getChatsFc()
		chat.start({
			dest: 'chat',
			act: 'load',
			chats: msj,
			generalQuestions: getGeneralQuestions('purchase'),
			cardWarning: cardWarning,
		})
	}
}

function beforeChat(detail) {
	const htmlFc = handler.getDataFc()
	const dataToSend = handler.getValuesForChat(detail, htmlFc)
	if (!dataToSend) return

	const fc = document.getElementById(`${detail.dest}-fullcont`)
	const lineCount = fc ? countMultitableLines(fc, 'purchase_form_purchase_vs_item') : 0

	const details = fc
		? [
				{ label: 'Purchase code', value: readFullcontField(fc, 'purchase_form_code') },
				{ label: 'Provider', value: readFullcontField(fc, 'purchase_form_provider_id') },
				{ label: 'Purchase date', value: readFullcontField(fc, 'purchase_form_date') },
				{
					label: 'Products in the detail',
					value: lineCount ? `${lineCount} line(s)` : '—',
				},
		  ]
		: [{ label: 'Status', value: 'Draft — the purchase has not been saved yet' }]

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Before saving',
		recordId: fc ? fc.getAttribute('data-dbid') || '—' : '—',
		details,
		scopeNote:
			'The assistant uses what you see on screen. If you have not saved the purchase, the chat history may be limited.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'purchaseBefore',
		entity: 'purchase',
		data: dataToSend,
		question: detail.question ?? '',
		ev: detail.ev,
		generalQuestions: getGeneralQuestions('purchaseBefore'),
		cardWarning: cardWarning,
	})
}

function submit(detail) {}

function typing(detail) {
	chatHandler.typing(detail)
}
